<template>
    <div class="common-body-view">
        <div  class="common-title">
            <img @click="back" src='../../img/left.png' style="width: 20px; height: 20px;">
            <span class="common-title-text">绑定手机</span>
        </div>

        <div class="main">
            <div class="green-tips-views">
                <span>建议绑定手机号，平台可通过手机号找回密码，平台将以绑定手机号作为账号拥有者的标记</span>
            </div>

            <div class="input-view">
                <van-field label="手机号码" label-width="60" type="digit" id="inputTel" maxlength="11" placeholder="请输入手机号码" class="common-input" v-model="tel" />
            </div>

            <div class="input-view">
                <van-field  label="验证码" label-width="60" type="digit" id="inputCode" maxlength="6" class="common-input" v-model="code" placeholder="请输入验证码">
                    <template #button>
                        <van-count-down
                                v-show="showCountDown"
                                ref="countDown"
                                :time="60000"
                                :auto-start="false"
                                format="ss秒重发"
                                style="font-size: 12px;color: #888888"
                                @finish="finish"
                        />
                        <span  style="color: #0f78e8;font-size: 12px;" v-show="!showCountDown" @click="sendCode">发送验证码</span>
                    </template>
                </van-field>
            </div>

            <van-button type="info" block native-type="submit" :loading="showLoading"
                        style="height: 35px;font-weight: bold;width: 100%;margin-top: 20px;"
                        loading-text="正在提交"  @click="submit"
                        color="#0f78e8">
                立即绑定
            </van-button>
        </div>
    </div>
</template>

<script>
    import {request} from '@/api/request'
    import Toast from "vant/lib/toast";

    export default {
        name: "sdk-tel",
        components: {
        },
        data() {
            return {
                showLoading: false,
                tel: '',
                code: '',
                showCountDown: false,
                telReg : /^1\d{10}$/,
                codeReg : /^\d{6}$/,
            }
        },
        mounted() {
            this.addInputBlur();
        },
        methods: {
            back() {
                this.$parent.$parent.closeTelPage();
            },
            finish() {
                this.showCountDown = false;
                this.$refs.countDown.reset();
            },
            sendCode() {
                if (!this.telReg.test(this.tel)) {
                    Toast('手机号码格式错误');
                    return ;
                }
                this.showLoading = true;
                let options = {
                    url:"/zfapp/sendSms",
                    data: {
                        phone: this.tel,
                        type: 2
                    }
                };
                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        this.showCountDown = true;
                        this.$refs.countDown.start();
                        Toast('验证码发送成功');
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            submit() {
                if (!this.telReg.test(this.tel)) {
                    Toast('手机号码格式错误');
                    return ;
                }
                if (!this.codeReg.test(this.code)) {
                    Toast('请输入6位数字验证码');
                    return ;
                }

                this.showLoading = true;
                let options = {
                    url:"/zfapp/bindPhone",
                    data: {
                        phone: this.tel,
                        checkCode: this.code
                    }
                };
                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        Toast('手机号码绑定成功');
                        let phone = res.data.data;
                        localStorage.setItem('phone', phone);
                        this.tel = '';
                        this.code = '';
                        this.back();
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            addInputBlur() {
                let isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 检测是否为ios
                if(!isIOS) {
                    console.log('不是iOS，取消blur事件');
                    return ;
                }
                let t = document.getElementById('inputCode');
                t.removeEventListener('blur', function(){ window.scrollTo(0,0)});
                t.addEventListener('blur', function(){window.scrollTo(0,0)}, false);

                let tel = document.getElementById('inputTel');
                tel.removeEventListener('blur', function(){ window.scrollTo(0,0)});
                tel.addEventListener('blur', function(){window.scrollTo(0,0)}, false)
            },
        }
    }
</script>

<style scoped>
    .van-cell {
        padding: 7px 10px;
    }
    /deep/ .van-field__control {
        color: #333333;
    }
</style>